



































import Vue from 'vue';
import { IFooterMobileComponent } from '../../../common/interfaces/footer.interface';
import { EFooterGroup } from '../../../common/enums/footer.enum';
import { EArrowDirection } from '../../../common/enums/index.enum';
import AboutUs from './AboutUs.vue';
import FooterHeadline from './FooterHeadline.vue';
import HelpAndContact from './HelpAndContact.vue';
import OpeningHours from './OpeningHours.vue';
import PaymentTypes from './PaymentTypes.vue';
import SocialMediaIcons from './SocialMediaIcons.vue';
import Legal from './Legal.vue';

export default Vue.extend({
  name: `FooterMobile`,
  components: {
    AboutUs,
    FooterHeadline,
    HelpAndContact,
    Legal,
    OpeningHours,
    PaymentTypes,
    SocialMediaIcons,
  },
  data(): IFooterMobileComponent {
    return {
      EArrowDirection,
      EFooterGroup,
      aboutUs: window.vueFooter.aboutUs,
      helpAndContact: window.vueFooter.helpAndContact,
      legal: window.vueFooter.legal,
      openingHours: window.vueFooter.openingHours,
      paymentTypes: window.vueFooter.paymentTypes,
      submenu: null,
    };
  },
  props: {
    newServiceTimesActive: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    getHeadline(group: EFooterGroup): string {
      return this.$t(this[group].headline);
    },
    isSelected(group: EFooterGroup) : boolean {
      if(!this.submenu) {
        return false;
      }
      return this.submenu === group;
    },
    toggle(group: EFooterGroup): void {
      this.submenu = this.submenu ? null : group;
    },
  },
});
